import React, { useState } from 'react';
import { Alert, Button, Card, CardBody, Col, Container, Row } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-c191254f72/icons'
import { useFormik, FormikProvider, Field } from "formik";

import { GalliumInput, GalliumSubmitButton } from "../../Components/Gallium/GalliumForms";

import useSWRMutation from 'swr/mutation'

import * as Yup from "yup";
import { Link } from 'gatsby';


const EmailCollection = () => {
    async function submitEmail(url, { arg }) {
        return fetch(url, {
          method: 'POST',
          body: JSON.stringify(arg)
        }).then(res => res.json())
      }

    const { trigger, isMutating } = useSWRMutation('https://hooks.zapier.com/hooks/catch/16177005/39uw04a/', submitEmail)

    const [formSuccess, setFormSuccess] = useState(false)

    const handleSubmitEmailFail = (error) => {
        // signupFormik.setErrors(error.response.data.errors || {})
        console.log(error)
    }

    const handleSubmitEmailSuccess = (data) => {
            setFormSuccess(true)
    }

    const handleSubmitEmailRequest = (values) => {
        const options = {
            onError(error) {
                handleSubmitEmailFail(error)
            },
            onSuccess(data) {
                handleSubmitEmailSuccess(data)
            },
            revalidate: false
        }
        trigger(values, options);
    }

    const signupFormik = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            type: "tech-updates",
            email: ""
        },
        validationSchema: Yup.object({
            email: Yup.string().email("Invalid Address").required("Please Enter Your Email"),
        }),
        onSubmit: (values) => {

            if (typeof window.posthog === 'function') {
                window.posthog.identify(values["email"],{ email: values["email"] })
            }

            handleSubmitEmailRequest(values)
        },
    });


    return (
        <React.Fragment>
            <section className="section mb-0 pb-0 pt-4" id="authors">
                <Container>
                    <FormikProvider className="tablelist-form" value={signupFormik}>
                        
                                <Row>
                                    <Col md={6}>
                                        <Card className='border card-border-success'>
                                            <CardBody>  
                                                <h5 className='text-success'>Want to know more about Gallium?</h5>
                                                <p className='text-muted mb-2'>You can run Gallium for free on your own servers today</p>
                                                <a target="_blank" href="https://docs.gallium.cloud">
                                                    <Button className='btn-label right btn-success mb-2'>
                                                        <span className='label-icon fs-16 align-middle'>
                                                            <FontAwesomeIcon icon={byPrefixAndName.fal['arrow-up-right-from-square']}/>
                                                        </span>
                                                        Documentation
                                                    </Button>
                                                </a>
                                                <Link to="/demo">
                                                    <Button className='btn-label right btn-soft-success ms-3 mb-2'>
                                                        <span className='label-icon fs-16 align-middle'>
                                                            <FontAwesomeIcon icon={byPrefixAndName.fal['server']} />
                                                        </span>
                                                        Try Gallium
                                                        </Button>
                                                </Link>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={6}>
                                        <Card className='border card-border-success'>
                                            <CardBody>  
                                                {formSuccess === true ? (
                                                <Alert color="success">
                                                    Thank You! .
                                                </Alert>
                                                ) : (
                                                <Row>
                                                    <Col md={12} className="">
                                                    <h5 className='text-success mb-2'>Receive Technical Updates</h5>
                                                    </Col>
                                                    <Col md={8} className='pt-1'>
                                                    
                                                        <Field
                                                            id="email"
                                                            name="email"
                                                            type="email"
                                                            placeholder="Enter your email address"
                                                            className="form-control"
                                                            component={GalliumInput}
                                                        />
                                                    </Col>
                                                    <Col md={4} className='pt-1'>
                                                        
                                                        <GalliumSubmitButton formik={signupFormik} spinner={isMutating} color="success"  className="w-100" >
                                                                        Submit
                                                        </GalliumSubmitButton>
                                                        
                                                    </Col>
                                                    <Col md={12} className="pt-2 pe-2">
                                                        <span className="text-muted fw-lighter">Max once a month. Read our <Link to="/Trust/Privacy">Privacy Policy.</Link></span>
                                                    </Col>
                                                </Row>
                                                )}
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            
                    </FormikProvider>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default EmailCollection;